import React, { useState, useEffect } from 'react'
import { Input, Select } from 'antd'
import { COUNTRIES, DEFAULT_COUNTRY, parsePhoneValue, buildPhoneValue } from '@/data/countries'

interface PhoneInputProps {
  value?: string
  onChange?: (value: string | undefined) => void
  placeholder?: string
  disabled?: boolean
  size?: 'large' | 'middle' | 'small'
}

const countryOptions = COUNTRIES.map(c => ({
  value: c.dialCode + '|' + c.code,
  label: `${c.flag} ${c.dialCode}`,
  searchText: `${c.name} ${c.dialCode} ${c.code}`.toLowerCase(),
}))

const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, placeholder, disabled, size }) => {
  const parsed = parsePhoneValue(value)
  const [dialCode, setDialCode] = useState(parsed.dialCode)
  const [number, setNumber] = useState(parsed.number)

  useEffect(() => {
    const p = parsePhoneValue(value)
    setDialCode(p.dialCode)
    setNumber(p.number)
  }, [value])

  const handleCountryChange = (val: string) => {
    const code = val.split('|')[0]
    setDialCode(code)
    onChange?.(buildPhoneValue(code, number))
  }

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const n = e.target.value.replace(/\s/g, '')
    setNumber(n)
    onChange?.(buildPhoneValue(dialCode, n))
  }

  const selectedOption = () => {
    const country = COUNTRIES.find(c => c.dialCode === dialCode) ?? DEFAULT_COUNTRY
    return `${country.dialCode}|${country.code}`
  }

  return (
    <Input.Group compact style={{ display: 'flex' }}>
      <Select
        value={selectedOption()}
        onChange={handleCountryChange}
        disabled={disabled}
        showSearch
        size={size}
        filterOption={(input, option) =>
          (option as any)?.searchText?.includes(input.toLowerCase()) ?? false
        }
        style={{ width: size === 'small' ? 88 : 100, flexShrink: 0 }}
        popupMatchSelectWidth={280}
        options={countryOptions}
        optionFilterProp="searchText"
      />
      <Input
        value={number}
        onChange={handleNumberChange}
        placeholder={placeholder ?? 'Numero di telefono'}
        disabled={disabled}
        size={size}
        style={{ flex: 1 }}
      />
    </Input.Group>
  )
}

export default PhoneInput
